import {
  differenceInDays,
  differenceInMonths,
  differenceInYears,
} from 'date-fns';

export const convertToDate = (dateComponents?: string) => {
  if (dateComponents == undefined) return undefined;

  const [day, month, year] = dateComponents.split('/');
  return new Date(+year, +month - 1, +day);
};

export const differenceDateAge = (effectiveDate: Date, dobDate: Date) => {
  const yearsDiff = differenceInYears(effectiveDate, dobDate);
  const monthsDiff = differenceInMonths(effectiveDate, dobDate);
  const daysDiff = differenceInDays(effectiveDate, dobDate);

  return {
    years: yearsDiff,
    months: monthsDiff,
    days: daysDiff,
  };
};

/**
 *
 * @param {Object} minAge - Minimum permissible age in years or days.
 * @param {Number} minAge.yearsOld - Minimum permissible years old.
 * @param {Number} minAge.daysOld - Minimum permissible days old.
 * @param {Object} maxAge - Maximum permissible age in years or days.
 * @param {Number} maxAge.yearsOld - Maximum permissible years old.
 * @param {Number} maxAge.daysOld - Maximum permissible days old.
 * @param {String} dobText - Date of birth in dd/MM/yyyy.
 */
export function isEligibleAge(
  minAge: { yearsOld: number; monthsOld?: number; daysOld?: number },
  maxAge: { yearsOld: number; monthsOld?: number; daysOld?: number },
  dobText: string,
  travelStartDate: string,
) {
  const dobDate = convertToDate(dobText) as Date;
  const startDate = convertToDate(travelStartDate) as Date;

  const minAgeDob = differenceDateAge(startDate, dobDate);
  const maxAgeDob = differenceDateAge(startDate, dobDate);

  const hasEligibleMinAge =
    minAge.yearsOld === 0 && minAge.daysOld !== undefined
      ? minAgeDob.days >= minAge.daysOld
      : minAgeDob.years >= minAge.yearsOld;
  const hasEligibleMaxAge = maxAgeDob.years <= maxAge.yearsOld;

  return hasEligibleMinAge && hasEligibleMaxAge;
}
